import { NgModule } from "@angular/core";
import { PricesTableCategoryItemComponent } from "./prices-table-category-item.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { PricesTableCategoryItemsModule } from "../prices-table-category-items/prices-table-category-items.module";

@NgModule({
  imports: [CommonModule, SharedModule, PricesTableCategoryItemsModule],
  exports: [PricesTableCategoryItemComponent],
  declarations: [PricesTableCategoryItemComponent],
})
export class PricesTableCategoryItemModule {}
